import React from "react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { replaceParamStudent } from "utils/helpers";
import { TableActions } from "components";
import { ROUTES } from "../../../../utils/constants";
import { Plus, Folder } from "../../../common/icons";
import Card from "./Card";

function Placement({
  storePlacement = { data: [], loading: false, error: null },
  onEdit = () => {},
  onDelete = () => {},
  onRequestChange = () => {},
  onVerify = () => {},
  documents = {},
}) {
  const history = useHistory();
  const { studentId } = useParams();

  const handleClick = () => {
    history.push(replaceParamStudent(ROUTES.addPlacement, studentId));
  };

  const columns1 = [
    {
      title: "Program",
      dataIndex: "program",
      render: (row) => (row.program ? row.program.name : "-"),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (row) => (row.is_type ? row.is_type : "-"),
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (row) =>
        // eslint-disable-next-line no-nested-ternary
        row.employment_placement && row.employment_placement.start_date
          ? moment(row.employment_placement.start_date).format("MM/DD/YYYY")
          : // eslint-disable-next-line no-nested-ternary
          row.military_placement && row.military_placement.created_at
          ? moment(row.military_placement.created_at).format("MM/DD/YYYY")
          : row.education_placement && row.education_placement.created_at
          ? moment(row.education_placement.created_at).format("MM/DD/YYYY")
          : "-",
    },
    {
      title: "Documentation",
      dataIndex: "files",
      render: (row) => {
        if (!row.files.length) return "-";

        return row.files.map((item) => (
          <a
            className="document"
            key={item.id || item.name}
            href={item.url}
            target="_blank"
            rel="noreferrer"
          >
            <Folder />
            {item.filename}
          </a>
        ));
      },
    },
    {
      title: "",
      dataIndex: "id",
      align: "right",
      render: (row) => {
        const changeRequest = row?.survey_result?.change_requests?.sort(
          (a, b) => {
            const date1 = new Date(a.created_at);
            const date2 = new Date(b.created_at);
            return date2 - date1;
          }
        )[0];

        const statusPending = changeRequest?.status === "pending";
        const statusPendingVerification =
          changeRequest?.status === "pending_verification";

        return (
          <div className="actions-with-notifications">
            <div className="notifications">
              {statusPendingVerification && <span>&bull;</span>}
            </div>
            <TableActions
              actions={[
                {
                  hidden: statusPending,
                  label: statusPendingVerification
                    ? "Re-Request Changes"
                    : "Request Change",
                  icon: ["fas", "comment"],
                  onSelect: onRequestChange(row),
                },
                {
                  hidden: statusPending || !documents[row.id],
                  label: statusPendingVerification
                    ? "Verify - Admin to Sign"
                    : "Verify",
                  icon: ["fas", "check"],
                  onSelect: onVerify(row),
                },
                // {
                //   hidden: !statusPending,
                //   label: "Cancel Change Request",
                //   icon: ["fas", "ban"],
                //   onSelect: onRequestChange(row),
                // },
                {
                  label: "Edit",
                  icon: ["fas", "pen-to-square"],
                  onSelect: onEdit(row),
                },
                {
                  label: "Delete",
                  icon: ["fas", "trash"],
                  onSelect: onDelete(row),
                },
              ]}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="Placement Student-tap dashboard__item__inner">
      <div className="button__add">
        <button type="submit" className="button--icon" onClick={handleClick}>
          <Plus />
          Placement
        </button>
      </div>
      <div>
        {storePlacement.data.map((item) => (
          <Card
            title={item.outcome ? item.outcome : ""}
            data={[item]}
            columns1={columns1}
            key={item.id}
          />
        ))}
      </div>
    </div>
  );
}

export default Placement;
